import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Drawer from "components/common/Drawer";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import { TOP_NAV_ITEMS } from "components/allInOneDashboard/constants/topNavConfig";
import {
  NAV_COLORS,
  ACTIVE_PILL_SX,
} from "components/allInOneDashboard/constants/navTheme";
import { BRAND_BLUE } from "components/allInOneDashboard/constants/mobileTheme";

const ICONS = {
  explore: ExploreOutlinedIcon,
  marketPulse: MicNoneOutlinedIcon,
  profile: PersonOutlineOutlinedIcon,
  blogs: ArticleOutlinedIcon,
};

const AllInOneSideDrawer = ({
  open,
  onClose,
  isActive,
  onItemClick,
  isItemDisabled,
  onLogoutClick,
}) => (
  <Drawer
    anchor="left"
    open={open}
    onClose={onClose}
    ModalProps={{ keepMounted: true }}
    PaperProps={{
      sx: {
        width: "min(320px, 86vw)",
        bgcolor: "#fff",
        borderRight: "1px solid #E5E7EB",
        boxShadow: "4px 0 24px rgba(0,0,0,0.08)",
      },
    }}
  >
    <Stack sx={{ height: "100%", pt: 2, pb: 3 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2.5, mb: 2 }}
      >
        <Text sx={{ fontWeight: 700, fontSize: 18, color: NAV_COLORS.nseText }}>
          Menu
        </Text>
        <Box
          component="button"
          type="button"
          aria-label="Close menu"
          onClick={onClose}
          sx={{
            width: 36,
            height: 36,
            border: "1px solid #E5E7EB",
            borderRadius: "10px",
            bgcolor: "#F9FAFB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            p: 0,
          }}
        >
          <CloseIcon sx={{ fontSize: 20, color: NAV_COLORS.nseText }} />
        </Box>
      </Stack>

      <Stack spacing={0.75} sx={{ px: 1.5 }}>
        {TOP_NAV_ITEMS.map((item) => {
          const active = isActive?.(item);
          const disabled = isItemDisabled?.(item);
          const Icon = ICONS[item.id] || ExploreOutlinedIcon;

          return (
            <Box
              key={item.id}
              component="button"
              type="button"
              disabled={disabled}
              onClick={() => {
                if (disabled) return;
                onItemClick?.(item);
                onClose?.();
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                width: "100%",
                textAlign: "left",
                border: 0,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.45 : 1,
                px: 1.75,
                py: 1.5,
                borderRadius: "14px",
                bgcolor: active ? undefined : "transparent",
                ...(active
                  ? {
                      ...ACTIVE_PILL_SX,
                      borderRadius: "14px",
                    }
                  : {
                      "&:hover": { bgcolor: "#F3F4F6" },
                    }),
              }}
            >
              <Icon
                sx={{
                  fontSize: 22,
                  color: active ? "#fff" : BRAND_BLUE,
                  flexShrink: 0,
                }}
              />
              <Text
                sx={{
                  fontWeight: active ? 700 : 600,
                  fontSize: 16,
                  color: active ? "#fff" : NAV_COLORS.nseText,
                }}
              >
                {item.label}
              </Text>
            </Box>
          );
        })}
      </Stack>

      {onLogoutClick ? (
        <Box sx={{ mt: "auto", px: 1.5 }}>
          <Box
            component="button"
            type="button"
            onClick={() => {
              onClose?.();
              onLogoutClick();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              width: "100%",
              textAlign: "left",
              border: 0,
              cursor: "pointer",
              px: 1.75,
              py: 1.5,
              borderRadius: "14px",
              bgcolor: "transparent",
              "&:hover": { bgcolor: "#FEF2F2" },
            }}
          >
            <LogoutOutlinedIcon
              sx={{ fontSize: 22, color: "#DC2626", flexShrink: 0 }}
            />
            <Text
              sx={{
                fontWeight: 600,
                fontSize: 16,
                color: "#DC2626",
              }}
            >
              Log Out
            </Text>
          </Box>
        </Box>
      ) : null}
    </Stack>
  </Drawer>
);

export default AllInOneSideDrawer;
